import React from 'react';
import { ReactComponent as Train } from '../../../../../../../resources/images/svg/train.svg';
import { useAuth } from '../../../../../../contexts/userContext/userContext';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

const rideTitleDetailClass = 'm-0 text-xs lg:text-sm';
function SearchRideTitle({ ride }) {
  const { currentLanguage } = useTranslation();
  const { ticketBookingOptions } = useAuth();

  const startStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${ride.actualStartStationCode}`,
  );
  const endStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${ride.actualEndStationCode}`,
  );

  return (
    <div className="flex justify-between w-full gap-2 flex-col xl:flex-row">
      <div className="flex gap-2 items-center">
        <Train />
        <div className="flex gap-2">
          <p className={rideTitleDetailClass}>
            N
            {ride.rideNumber}
          </p>
          <p className={rideTitleDetailClass}>
            {
              startStation?.[`label_${currentLanguage}`]
            || startStation?.label_ka
            }
          </p>
          -
          <p className={rideTitleDetailClass}>
            {
                endStation?.[`label_${currentLanguage}`]
                || endStation?.label_ka
            }
          </p>
        </div>
      </div>
    </div>
  );
}

export default SearchRideTitle;
